const CHARS_COUNT = {
  Y: 4,
  M: 2,
  D: 2
};

// From moment.js
const DATE_FORMATS = {
  ar: 'DD/MM/YYYY',
  bg: 'DD.MM.YYYY',
  cn: 'YYYY/MM/DD',
  cs: 'DD.MM.YYYY',
  de: 'DD.MM.YYYY',
  en: 'MM/DD/YYYY',
  es: 'DD/MM/YYYY',
  fr: 'DD/MM/YYYY',
  he: 'DD/MM/YYYY',
  hu: 'YYYY.MM.DD.',
  it: 'DD/MM/YYYY',
  ja: 'YYYY/MM/DD',
  ko: 'YYYY.MM.DD.',
  pl: 'DD.MM.YYYY',
  pt: 'DD/MM/YYYY',
  ro: 'DD.MM.YYYY',
  ru: 'DD.MM.YYYY',
  th: 'DD/MM/YYYY',
  tr: 'DD.MM.YYYY',
  tw: 'YYYY/MM/DD',
  vi: 'DD/MM/YYYY',
  zh: 'DD/MM/YYYY'
};

export const changeFormat = (from, to, value) => {
  if (!value) return value;
  let res = to;
  Object.keys(CHARS_COUNT).forEach(char => {
    const start = from.indexOf(char);
    const end = from.lastIndexOf(char);

    res = res.replace(new Array(end - start + 2).join(char), value.substring(start, end + 1));
  });
  return res;
};

export const getDateFormat = lang => DATE_FORMATS[lang];

export const insertLabelsToFormat = format =>
  format
    .replace(/Y{4}/, '{year}')
    .replace(/M{2}/, '{month}')
    .replace(/D{2}/, '{day}');

export const intlData = lang => ({
  __date_format: insertLabelsToFormat(getDateFormat(lang))
});



// WEBPACK FOOTER //
// ./utils/date.js